import { useIsOptimizedAudioBarsEnabled } from '@/features/flags';
import type { ComponentProps } from 'react';
import { DesktopBars as LegacyDesktopBars } from './legacy/DesktopBars';
import { DesktopBars as OptimizedDesktopBars } from './optimized/DesktopBars';

/**
 * SCR-6633 rollout switch: ON renders the compositor-backed optimized bars,
 * OFF the pre-SCR-6633 implementation (byte-identical under `legacy/`).
 */
export const DesktopBars = (props: ComponentProps<typeof OptimizedDesktopBars>) =>
  useIsOptimizedAudioBarsEnabled() ? (
    <OptimizedDesktopBars {...props} />
  ) : (
    <LegacyDesktopBars {...props} />
  );
